import { Container } from 'typedi';
import { BaseSessionManager } from './base-session-manager';
import { UserDataStoreDeferredObjectToken } from '../../injection-tokens';

export class SessionManager extends BaseSessionManager {
    constructor() {
        super();
        void this._tryAutoLogin();
        const dataStoreReady = Container.get(UserDataStoreDeferredObjectToken);
        dataStoreReady.promise.then(this._onDataStoreReady);
        this._setTimerId();
    }
}
